/* ============================================================
   Dynasty pricing — Greedy-Cap model + T-Shirt/Short combo
   ------------------------------------------------------------
   Base prices and bundle prices are expressed in WHOLE EGP (LE).
   Display code multiplies by 100 to convert to cents for | money.
   Flat shipping (80 EGP) is added once at the total, never discounted.
============================================================ */
var TSHIRT_PRICE       = 590;   // 1 tee
var SHORTS_PRICE       = 490;   // 1 short
var COMBO_BUNDLE_PRICE = 1000;  // 1 tee + 1 short paired together
var DYNASTY_SHIPPING   = 80;    // flat, never discounted

/* Back-compat alias object (cents) for any legacy reference. */
var DYNASTY_PRICES = {
  tshirt: TSHIRT_PRICE * 100,
  short:  SHORTS_PRICE * 100,
  combo:  COMBO_BUNDLE_PRICE * 100
};

/* Full price for N t-shirts — no multi-unit discount, only the T+S combo saves. */
function tshirtTotalLE(n) {
  return n > 0 ? n * TSHIRT_PRICE : 0;
}

/* Full price for N shorts — no multi-unit discount, only the T+S combo saves. */
function shortsTotalLE(n) {
  return n > 0 ? n * SHORTS_PRICE : 0;
}

/* Combined total (LE): pair ALL possible (tee + short) combos at 1000 LE each,
   then charge full price for remaining items in each category. */
function comboTotalLE(tCount, sCount) {
  var comboCount = Math.min(tCount, sCount);
  return comboCount * COMBO_BUNDLE_PRICE +
         tshirtTotalLE(tCount - comboCount) +
         shortsTotalLE(sCount - comboCount);
}

/* Undiscounted total (LE) — what the strikethrough "was" price shows. */
function originalTotalLE(tCount, sCount) {
  return tCount * TSHIRT_PRICE + sCount * SHORTS_PRICE;
}

/* Shared pricing API used by the cart template. */
window.DynastyPricing = {
  TSHIRT_PRICE: TSHIRT_PRICE,
  SHORTS_PRICE: SHORTS_PRICE,
  COMBO_BUNDLE_PRICE: COMBO_BUNDLE_PRICE,
  SHIPPING: DYNASTY_SHIPPING,
  tshirtTotalLE: tshirtTotalLE,
  shortsTotalLE: shortsTotalLE,
  comboTotalLE: comboTotalLE,
  originalTotalLE: originalTotalLE
};

/* Classify a Shopify cart line and return Greedy-Cap totals in cents.
   Non-apparel items keep their own line price and are added untouched. */
function getDynastyCart(cartItems) {
  var tshirts = 0;
  var shorts = 0;
  var otherCents = 0;

  cartItems.forEach(function(item) {
    var type = (item.product_type || '').toLowerCase().trim();
    var title = (item.product_title || item.title || '').toLowerCase();
    var tags = Array.isArray(item.tags)
      ? item.tags.join(',').toLowerCase()
      : (item.tags || '').toLowerCase();

    var isTshirt = type === 't-shirts' || type === 't-shirt' || type === 'tshirt' ||
                   tags.indexOf('t-shirt') > -1 || tags.indexOf('tshirt') > -1 ||
                   title.indexOf('shirt') > -1;
    var isShort  = type === 'shorts' || type === 'short' ||
                   tags.indexOf('short') > -1 || title.indexOf('short') > -1;

    if (isTshirt) tshirts += item.quantity;
    else if (isShort) shorts += item.quantity;
    else otherCents += (item.line_price || (item.price * item.quantity) || 0);
  });

  var subtotalCents = comboTotalLE(tshirts, shorts) * 100 + otherCents;
  var originalCents = originalTotalLE(tshirts, shorts) * 100 + otherCents;

  return {
    tshirts: tshirts, shorts: shorts,
    original: originalCents,
    savings: originalCents - subtotalCents,
    subtotal: subtotalCents,
    total: subtotalCents + DYNASTY_SHIPPING * 100
  };
}

(function () {
  'use strict';

  // Header scroll effect
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function() { header.classList.toggle('scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile nav drawer
  var hamburger = document.querySelector('.hamburger');
  var navDrawer = document.querySelector('.nav-drawer');
  var navOverlay = document.querySelector('.nav-drawer__overlay');
  var navClose = document.querySelector('.nav-drawer__close');

  function openDrawer() {
    if (!navDrawer) return;
    hamburger && hamburger.classList.add('active');
    navDrawer.classList.add('open');
    navDrawer.removeAttribute('aria-hidden');
    navDrawer.removeAttribute('inert');
    navOverlay && navOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!navDrawer) return;
    hamburger && hamburger.classList.remove('active');
    navDrawer.classList.remove('open');
    navDrawer.setAttribute('aria-hidden', 'true');
    navDrawer.setAttribute('inert', '');
    navOverlay && navOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  hamburger && hamburger.addEventListener('click', openDrawer);
  navClose && navClose.addEventListener('click', closeDrawer);
  navOverlay && navOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

  // Collection filter tabs (collection page only)
  var filterTabs = document.querySelectorAll('.filter-tab');
  var productCards = document.querySelectorAll('.product-card[data-category]');
  if (filterTabs.length && productCards.length) {
    filterTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        filterTabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var category = tab.dataset.filter;
        productCards.forEach(function(card) {
          if (category === 'all' || card.dataset.category === category) {
            card.style.display = '';
            card.style.animation = 'fadeIn 0.3s ease';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // Add to cart on collection cards
  document.querySelectorAll('.product-card__add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var self = this;
      self.textContent = 'Adding...';
      self.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        self.textContent = 'Added!';
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        setTimeout(function() { self.textContent = 'Add to Cart'; self.disabled = false; }, 1800);
      })
      .catch(function() { self.textContent = 'Add to Cart'; self.disabled = false; });
    });
  });

  // Newsletter form (footer)
  var newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = this.querySelector('input[type="email"]').value;
      if (!email) return;
      var btn = this.querySelector('button');
      btn.textContent = 'Subscribed!';
      setTimeout(function() { btn.textContent = 'Join'; }, 3000);
    });
  }

  // Register page validation — guard keeps this from running on every page
  var registerForm = document.getElementById('register-form');
  if (registerForm) {
    registerForm.querySelectorAll('.auth-form__eye').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.getElementById(btn.dataset.target);
        if (!input) return;
        var isText = input.type === 'text';
        input.type = isText ? 'password' : 'text';
        btn.querySelector('svg').style.opacity = isText ? '0.35' : '0.8';
      });
    });

    var passwordInput = document.getElementById('reg-password');
    var strengthFill = document.getElementById('strength-fill');
    var strengthLabel = document.getElementById('strength-label');

    function getStrength(pw) {
      var score = 0;
      if (pw.length >= 8) score++;
      if (pw.length >= 12) score++;
      if (/[A-Z]/.test(pw)) score++;
      if (/[0-9]/.test(pw)) score++;
      if (/[^A-Za-z0-9]/.test(pw)) score++;
      return score;
    }

    var STRENGTH_MAP = [
      { label: '', color: 'transparent', pct: '0%' },
      { label: 'Weak', color: '#ef4444', pct: '25%' },
      { label: 'Fair', color: '#f97316', pct: '50%' },
      { label: 'Good', color: '#eab308', pct: '75%' },
      { label: 'Strong', color: '#22c55e', pct: '100%' }
    ];

    if (passwordInput) {
      passwordInput.addEventListener('input', function() {
        var score = Math.min(getStrength(passwordInput.value), 4);
        var map = STRENGTH_MAP[passwordInput.value.length ? score : 0];
        if (strengthFill) { strengthFill.style.width = map.pct; strengthFill.style.background = map.color; }
        if (strengthLabel) { strengthLabel.textContent = map.label; strengthLabel.style.color = map.color; }
      });
    }

    var emailInput = document.getElementById('reg-email');
    var emailError = document.getElementById('email-error');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailInput) {
      emailInput.addEventListener('blur', function() {
        var valid = EMAIL_RE.test(emailInput.value.trim());
        emailInput.classList.toggle('is-invalid', !valid && emailInput.value.length > 0);
        emailInput.classList.toggle('is-valid', valid);
        if (emailError) emailError.textContent = (!valid && emailInput.value.length > 0) ? 'Please enter a valid email address.' : '';
      });
    }

    var confirmInput = document.getElementById('reg-password-confirm');
    var confirmError = document.getElementById('confirm-error');
    var passwordError = document.getElementById('password-error');

    function validatePasswordMatch() {
      if (!confirmInput || !confirmInput.value) return true;
      var match = passwordInput.value === confirmInput.value;
      confirmInput.classList.toggle('is-invalid', !match);
      confirmInput.classList.toggle('is-valid', match);
      if (confirmError) confirmError.textContent = match ? '' : 'Passwords do not match.';
      return match;
    }

    confirmInput && confirmInput.addEventListener('input', validatePasswordMatch);
    confirmInput && confirmInput.addEventListener('blur', validatePasswordMatch);

    registerForm.addEventListener('submit', function(e) {
      var valid = true;
      if (emailInput && !EMAIL_RE.test(emailInput.value.trim())) {
        emailInput.classList.add('is-invalid');
        if (emailError) emailError.textContent = 'Please enter a valid email address.';
        valid = false;
      }
      if (passwordInput && passwordInput.value.length < 8) {
        passwordInput.classList.add('is-invalid');
        if (passwordError) passwordError.textContent = 'Password must be at least 8 characters.';
        valid = false;
      }
      if (!validatePasswordMatch()) valid = false;
      if (!valid) { e.preventDefault(); var inv = registerForm.querySelector('.is-invalid'); if (inv) inv.focus(); }
    });
  }

  // Announcement bar ticker duplicate for seamless loop
  var track = document.querySelector('.announcement-bar__track');
  if (track) { var clone = track.innerHTML; track.innerHTML = clone + clone; }

})();
